import { useMutation } from '@apollo/client';
import { CreateInvitedUserInput } from '__generated__/globalTypes';
import gql from 'graphql-tag';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const CREATE_INVITED_USER_MUTATION = gql`
  mutation createInvitedUser($input: CreateInvitedUserInput!) {
    createInvitedUser(input: $input) {
      id
      inactive
    }
  }
`;

type UseCreateInvitedUserArgs = {
  onSuccess?(): void;
};

export const useCreateInvitedUser = ({
  onSuccess,
}: UseCreateInvitedUserArgs = {}) => {
  const [error, setError] = useState('');
  const { t: translate } = useTranslation('logged_out');

  const [mutateCreateInvitedUser] = useMutation(CREATE_INVITED_USER_MUTATION, {
    onCompleted: () => {
      onSuccess?.();
      setError(''); // reset error if it previously failed
    },
    onError: () => {
      setError(translate('login.errors.default_login_error'));
    },
  });

  const createInvitedUser = async (input: CreateInvitedUserInput) => {
    await mutateCreateInvitedUser({ variables: { input } });
  };

  return { createInvitedUser, error };
};
